module.exports = __webpack_public_path__ + "img/61bfbb9.jpg";